import $ from 'jquery';

export default function setupSearch () {
    $('#search-open-button').on('click', toggleSearch);

	function toggleSearch(e) {
		e.preventDefault();
		$('html').toggleClass('js-search');
	}
}
